module.exports = __webpack_public_path__ + "img/mug_130.73ee0656.jpg";